import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    PartyProductModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class PartyProductsDataService implements CrudService<PartyProductModel, PartyProductModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<PartyProductModel>): Promise<CrudListResponse<PartyProductModel>> {
        return ApiService.api.getPartyProductBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PartyProductModel>> {
        return ApiService.api.getPartyProductById(id, params);
    }

    create(item: PartyProductModel, params?: RequestParams): Promise<CrudResponse<PartyProductModel>> {
        return ApiService.api.insertPartyProduct(item, params);
    }

    update(item: PartyProductModel, params?: RequestParams): Promise<PartyProductModel> {
        return ApiService.api.updatePartyProduct(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PartyProductModel> {
        return ApiService.api.patchPartyProduct(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PartyProductModel>): Promise<CrudListResponse<PartyProductModel>> {
        return ApiService.api.deletePartyProducts(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<PartyProductModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
